import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {ApiError, ProblemDetails} from "@esa/api";
import {Action} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class ApiErrorHandlerService {
  constructor(
    private toastrService: ToastrService,
  ) {}

  handleError(error: ApiError, action: Action): Observable<Action>{
    const errorBody = error.body as ProblemDetails;
    const errorMessage = errorBody.detail ? errorBody.title + ': ' + errorBody.detail : error.body;
    this.toastrService.error(errorMessage);
    console.warn(errorMessage);
    return of(action);
  }
}
